import React from "react";

export default function CurrencyMarketSelect({
  t,
  value,
  options = [],
  onChange,
  labelClassName = "",
  selectClassName = "",
  wrapperClassName = "",
}) {
  if (typeof onChange !== "function" || options.length === 0) return null;

  return (
    <label
      className={`flex max-w-full items-center gap-4 ${wrapperClassName}`.trim()}
    >
      <span
        className={`shrink-0 text-[12px] font-medium uppercase tracking-[0.16em] ${labelClassName}`.trim()}
      >
        {t("Checkout Currency", { defaultValue: "Checkout Currency" })}
      </span>
      <select
        value={value || ""}
        onChange={(event) => onChange(event.target.value)}
        className={`min-w-0 rounded-full border px-4 py-2 text-sm font-medium outline-none transition-colors ${selectClassName}`.trim()}
      >
        {options.map((option) => (
          <option
            key={option.countryCode}
            value={option.countryCode}
          >
            {option.label} · {option.currencyCode}
          </option>
        ))}
      </select>
    </label>
  );
}
